import { ContentCopyOutlined } from '@mui/icons-material'
import { Box, Checkbox, IconButton, Tooltip, Typography } from '@mui/material'
import { LocalizedButton } from 'components/Localization/LocalizedButton'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { useDrawingChecklistCallbacks } from 'features/Drawings/CheckList/useDrawingChecklist'
import { isEqual } from 'lodash'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  PdfFeature,
  PdfPage,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppSelector } from 'store/configureStore'
import { Highlight } from './HighlightTypes'
import { handleCopyToClipboard } from './handleCopyToClipboard'

const useHighlightTitle = (highlight: Highlight, featureIndex: number) => {
  const [copied, setCopied] = useState(false)
  const [currentClipboardContent, setCurrentClipboardContent] =
    useState<string>(null)

  const checkListItem = useAppSelector((state) => {
    const currentCheckList = state.project.currentCheckList

    if (!currentCheckList) {
      return null
    }

    return Object.values(currentCheckList.checkList ?? {})
      .flat()
      .find((item) => item.featureId === highlight.pdfFeature.id)
  }, isEqual)

  return {
    currentClipboardContent,
    setCurrentClipboardContent,
    copied,
    checkListItem,
  }
}

export const HighlightTitle = (props: {
  bomItemPointer: BomItemPointer
  pdfPage: PdfPage
  pdfFeature: PdfFeature
  featureIndex: number
  highlight: Highlight
  isActiveCheckListFeature: boolean
  isCheckListFeature: boolean
  isDoneCheckListFeature: boolean
}) => {
  const { t } = useTranslation()
  const { copied, checkListItem, setCurrentClipboardContent } =
    useHighlightTitle(props.highlight, props.featureIndex)

  const { handleCompleteTodo, handleDismissTodo, handleReactivateTodo } =
    useDrawingChecklistCallbacks(props.bomItemPointer)

  if (!checkListItem) {
    return (
      <div>
        <div>
          {props.pdfFeature.name &&
            props.pdfFeature.name !== '@@@TBD' &&
            props.pdfFeature.name !== '?' && (
              <>
                <Typography variant="caption" color="body2" fontSize={'bold'}>
                  {t(`project:eng-drawing-${props.pdfFeature?.name}`)}
                </Typography>
              </>
            )}
          {/* <Typography variant="body1">
            {props.pdfFeature?.clipboardContent}
          </Typography> */}
        </div>
        <LocalizedTypography
          translationKey="project:checklist-create-item"
          variant="caption"
          color="textSecondary"
        >
          click to create a check list item
        </LocalizedTypography>
      </div>
    )
  }

  return (
    <Box>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
          gap: '2rem',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
          <Checkbox
            checked={checkListItem.done}
            onChange={(_, checked) => {
              if (checked) {
                handleCompleteTodo(checkListItem.itemId, checkListItem.category)
              } else {
                handleReactivateTodo(
                  checkListItem.itemId,
                  checkListItem.category,
                )
              }
            }}
            color="primary"
            size="small"
          />
          <div>
            {props.pdfFeature.name &&
              props.pdfFeature.name !== '@@@TBD' &&
              props.pdfFeature.name !== '?' && (
                <Typography variant="caption" color="textSecondary">
                  {t(`project:eng-drawing-${props.pdfFeature?.name}`)}
                </Typography>
              )}
            <Typography variant="body1">
              {checkListItem?.customDescription || checkListItem?.description}
            </Typography>
          </div>
        </div>
        <Tooltip title={copied ? 'Copied!' : 'Click to copy to clipboard'}>
          <IconButton
            size="small"
            onClick={() => {
              setCurrentClipboardContent(props.pdfFeature.clipboardContent)
              handleCopyToClipboard(props.pdfFeature.clipboardContent)
            }}
          >
            <ContentCopyOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          width: '100%',
        }}
      >
        {checkListItem?.done === false && (
          <>
            {/* <LocalizedButton
              translationKey="project:checklist-item-dismiss"
              defaultText="dismiss"
              size="small"
              variant="text"
              onClick={() =>
                handleDismissTodo(checkListItem.itemId, checkListItem.category)
              }
              color="secondary"
            /> */}
            <LocalizedButton
              translationKey="project:checklist-item-complete"
              defaultText="complete"
              size="small"
              variant="text"
              onClick={() =>
                handleCompleteTodo(checkListItem.itemId, checkListItem.category)
              }
            />
          </>
        )}
      </div>
    </Box>
  )
}
